import { render, staticRenderFns } from "./DetialIconGroup.vue?vue&type=template&id=657fb8f5&scoped=true"
import script from "./DetialIconGroup.vue?vue&type=script&lang=js"
export * from "./DetialIconGroup.vue?vue&type=script&lang=js"
import style0 from "./DetialIconGroup.vue?vue&type=style&index=0&id=657fb8f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657fb8f5",
  null
  
)

export default component.exports